import React, { useEffect, useState } from "react";
import { transferOffers } from "../transferMarket";
import Flag from "../../components/Flag";

const STATS = ["PAC", "SHO", "PAS", "DRI", "DEF", "PHY"];

// function Face({ player, size = "w-11 h-11" }) {
//   const [err, setErr] = useState(false);
//   if (!player.faceUrl || err) {
//     return (
//       <div
//         className={`${size} rounded-full bg-zinc-800 border border-zinc-700 grid place-items-center text-zinc-600 shrink-0`}
//       >
//         <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
//           <path d="M12 12a5 5 0 100-10 5 5 0 000 10zm0 2c-4.418 0-8 2.239-8 5v3h16v-3c0-2.761-3.582-5-8-5z" />
//         </svg>
//       </div>
//     );
//   }
//   return (
//     <img
//       src={player.faceUrl}
//       alt=""
//       onError={() => setErr(true)}
//       referrerPolicy="no-referrer"
//       className={`${size} rounded-full object-cover bg-zinc-800 border border-zinc-700 shrink-0`}
//     />
//   );
// }

export default function TradeWindowModal({
  open,
  roster,
  slots,
  onTrade,
  onSkip,
}) {
  const [view, setView] = useState("pick"); // pick | offers
  const [slotId, setSlotId] = useState(null);
  const [offers, setOffers] = useState([]);

  useEffect(() => {
    if (open) {
      setView("pick");
      setSlotId(null);
      setOffers([]);
    }
  }, [open]);

  if (!open) return null;

  const slotMap = {};
  slots.forEach((s) => (slotMap[s.id] = s));
  const lockedList = slots
    .map((s) => ({ slot: s, player: roster[s.id] }))
    .filter((x) => x.player);
  const outgoing = slotId ? roster[slotId] : null;
  const outSlot = slotId ? slotMap[slotId] : null;

  const scout = (sid) => {
    setSlotId(sid);
    setOffers(transferOffers(slotMap[sid], roster[sid], roster));
    setView("offers");
  };

  const statClass = (cand, k) => {
    const c = cand.attrs[k];
    const o = outgoing?.attrs?.[k] ?? c;
    if (c > o) return "text-emerald-400";
    if (c < o) return "text-red-400";
    return "text-zinc-300";
  };

  return (
    <div
      className="fixed inset-0 z-[70] bg-black/70 backdrop-blur-md grid place-items-center p-6"
      onClick={onSkip}
    >
      <div
        className="bg-zinc-950 border border-zinc-800 rounded-2xl w-full max-w-3xl
                   max-h-[92vh] overflow-y-auto scrollbar-fancy p-7
                   animate-scale-in shadow-2xl shadow-black/50"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between mb-5">
          <div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-emerald-500/80">
              January transfer window
            </div>
            <h3 className="text-lg font-bold text-zinc-100 mt-1">
              {view === "pick"
                ? "Make one transfer — or skip"
                : `Offers for ${outSlot?.label}`}
            </h3>
          </div>
          <button
            onClick={onSkip}
            className="text-sm text-zinc-400 hover:text-zinc-200 transition shrink-0 mt-1"
          >
            Skip window
          </button>
        </div>

        {view === "pick" ? (
          <>
            <p className="text-sm text-zinc-500 mb-4">
              Pick one of your players to put on the market and scout
              replacements.
            </p>
            <div className="space-y-2">
              {lockedList.map(({ slot, player }) => (
                <button
                  key={slot.id}
                  onClick={() => scout(slot.id)}
                  className="w-full flex items-center gap-3 rounded-xl bg-zinc-900/50 border border-zinc-800
                             px-4 py-3 text-left hover:border-emerald-500/50 hover:bg-zinc-900/80 transition"
                >
                  <span className="text-[10px] font-bold uppercase tracking-wider text-zinc-500 w-8 shrink-0">
                    {slot.label}
                  </span>
                  {/* <Face player={player} size="w-9 h-9" /> */}
                  <span className="font-semibold text-zinc-100 truncate flex-1">
                    <Flag
                      nation={player.nation}
                      className="text-base shrink-0"
                    />{" "}
                    {player.name}
                  </span>
                  <span className="text-xs text-emerald-400 font-semibold shrink-0">
                    Scout →
                  </span>
                </button>
              ))}
            </div>
          </>
        ) : (
          <>
            <div className="flex items-center gap-3 rounded-xl bg-zinc-900/40 border border-zinc-800 px-4 py-2.5 mb-4">
              <span className="text-[10px] uppercase tracking-widest text-zinc-500">
                Out
              </span>
              {/* <Face player={outgoing} size="w-8 h-8" /> */}
              <span className="text-sm font-semibold text-zinc-200 truncate">
                {outgoing?.name}
              </span>
              <div className="ml-auto hidden sm:grid grid-cols-6 gap-2 text-center">
                {STATS.map((k) => (
                  <div key={k} className="w-8">
                    <div className="text-xs font-semibold text-zinc-400 tabular-nums">
                      {outgoing?.attrs?.[k]}
                    </div>
                    <div className="text-[8px] text-zinc-600">{k}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              {offers.map((cand) => (
                <button
                  key={cand.id}
                  onClick={() => onTrade(slotId, cand)}
                  className="rounded-xl bg-zinc-900/50 border border-zinc-800 p-4 text-left
                             hover:border-emerald-500/60 hover:bg-zinc-900/80 transition flex flex-col"
                >
                  <div className="flex items-center gap-2.5 mb-3">
                    {/* <Face player={cand} size="w-10 h-10" /> */}
                    <div className="min-w-0">
                      <div className="text-sm font-semibold text-zinc-100 truncate">
                        {cand.name}
                      </div>
                      <div className="text-[11px] text-zinc-500 flex items-center gap-1.5 mt-0.5">
                        <Flag nation={cand.nation} className="text-xs" />
                        <span className="truncate">
                          {(cand.positions || [cand.pos]).join(" · ")}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="grid grid-cols-3 gap-2 mt-auto">
                    {STATS.map((k) => (
                      <div key={k} className="text-center">
                        <div
                          className={`text-sm font-bold tabular-nums ${statClass(cand, k)}`}
                        >
                          {cand.attrs[k]}
                        </div>
                        <div className="text-[9px] text-zinc-600">{k}</div>
                      </div>
                    ))}
                  </div>
                  <div className="mt-3 text-center text-xs font-semibold text-emerald-400">
                    Sign
                  </div>
                </button>
              ))}
            </div>

            <div className="mt-5 flex items-center justify-between">
              {/* <button
                onClick={() => setView("pick")}
                className="text-sm text-zinc-400 hover:text-zinc-200 transition"
              >
                ← Back to squad
              </button> */}
              {/* <button
                onClick={onSkip}
                className="text-sm text-zinc-500 hover:text-zinc-300 transition"
              >
                Skip window
              </button> */}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
